import { parseToTree } from '../parseToTree/parseToTree';
import { parseTreeToHtml } from '../parseTreeToHtml/parseTreeToHtml';

export const parseToHtml = (text: string): string => {
  const tree = parseToTree({ text });
  return parseTreeToHtml(tree);
};
